export default "__VITE_ASSET__eAmP13mV__"